import { Box, Stack, Typography } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { colours } from '../../StyleConstants';

type YouTubeVideoProps = {
  id: string;
  title: string;
  videoId: string;
  thumbnailUrl: string;
}

const YouTubeVideoCard = ({
    title,
    videoId,
    thumbnailUrl,
}: YouTubeVideoProps) => {
  
    function handleClick() {
        window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank", "noopener,noreferrer");
    }

    return (
        <Stack
            gap={2}
            sx={{ cursor: 'pointer' }}
            margin={1}
        >
            <Box
                onClick={handleClick}
                onKeyUp={(e) => {
                    if (e.key === "Enter") {
                        handleClick()
                    }
                }}
                tabIndex={0}
                aria-label={title}
                component="a"
                position="relative"
                sx={{
                    backgroundColor: "#E5F0FB",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    "&:focus": {
                        border: `3px solid ${colours.notifications.info50}`
                    }
                }}
            >
                <Box
                    component="img"
                    sx={{
                        height: '200px',
                        width: '100%',
                    }}
                    src={thumbnailUrl}
                    alt={`${title} thumbnail`}
                />

                <PlayCircleOutlineIcon
                    sx={{
                        position: 'absolute',
                        zIndex: 1,
                        fontSize: '48px',
                        color: '#FFFFFF',
                        cursor: 'pointer',
                    }}
                />
            </Box>

            <Typography fontSize="16px" fontWeight="400">{title}</Typography>
        </Stack>
    )
}

export default YouTubeVideoCard;